import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ProductService } from '../../../services/product.service';
import { Product } from '../../../models/Product';
import { User } from '../../../models/User';
import * as $ from 'jquery';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnChanges {
  @Input('product') product:Product;  //linked to parent 'products', will initially be null until products are loaded
  @Input('user') user:User;  //could be null.  needed to toggle the edit button for admin users that are logged in.
  category:string = null;
  sku:string = null;
  // product?: Product;  //will be null until getProduct responds.
  gallery:[number] = [1,2,3,4,5,6];
  glutenFreeOption: boolean = false;
  veganOption: boolean = false;
  totalPrice:number = 0

  constructor(
    private activatedRoute:ActivatedRoute,
    private productService: ProductService
  ) { }

  //Input products is initially null.  When 'products' loads async, grab product by sku and re-adjust height of textarea boxes.
  ngOnChanges(changes: SimpleChanges){
    console.log('pd - onChanges with product', this.product);
    this.activatedRoute.params.first().subscribe((params: Params) => {
      // console.log('pd - onchanges observed updated product', this.product);
      this.updatePriceTotal();
    });
  }


  clickedGlutenFree($event){
    //have to use jquery instead of $event, since button's internal div captures the $event 
    let button = $('button.glutenfree');  
    console.log(button);
    button.blur();  //remove focus/outline from button
    this.glutenFreeOption = !this.glutenFreeOption;
    this.updatePriceTotal();
  }

  clickedVegan($event){
    let button = $('button.vegan');
    button.blur();
    this.veganOption = !this.veganOption;
    this.updatePriceTotal();
  }

  updatePriceTotal(){
    //guard against null product (product is initially null)
    if(!this.product){
      return;
    }
    let originalPrice = this.product.product_price;
    let glutenFreePrice = this.glutenFreeOption ? 5 : 0;
    let veganPrice = this.veganOption ? 5 : 0;
    let totalPrice = originalPrice + glutenFreePrice + veganPrice;
    this.totalPrice = totalPrice;
  }
}



//Unused Code

//get the product from the service
// this.productService.getProducts().subscribe((response:ProductResponse) => {
//   this.products = Product.fromJsonList(response.products); //convert service observable to product[]
//   let product = this.products.filter((product) => {
//     return product.sku == this.sku;
//   });
// },
// err => {
//   console.log(err);
//   return false;
// });
// console.log('products: params.category:', params["category"]);
// console.log('products: params.productid:', params["productid"]);


  // this.productdate = new Date(this.product.updated_at); //not needed here //convert timestamp to Date
  //wait a tick for dom to reload with new products.
  // *must use af to access 'this'.  https://stackoverflow.com/questions/41106125/angular-2-using-this-inside-settimeout
  // setTimeout(() => {
  //   this.adjustHeightAllElements();
  // }, 0);      
  // ngOnInit() {
  //   this.activatedRoute.params.subscribe((params: Params) => {
  //     //use route params to set local properties
  //     this.category = params["category"];
  //     this.sku = params["sku"];

  //     //products were loaded by product.component.ts
  //     this.productService.product$.subscribe((products) => {
  //       // console.log('prod-detail observed new products', products);
  //       let filteredProduct = this.productService.getProductBySku(this.sku);
  //       // console.log('p-detail: filteredProduct by sku', filteredProduct);  
  //       this.product = filteredProduct;
  //       this.updatePriceTotal();        
  //     });

  //   });
  // }



  // //use route params to set local properties
  // this.sku = params["sku"];
  // //guard against empty product
  // if (this.product == null){
    //   console.log('pd - no products')
    //   this.productCopy = null;
    //   return;          
    // } else {
    //   this.productCopy = Product.fromJson(this.product);  //to get a new product copy.  local has a copy, so we can track changes from original upon save
    //   this.updatePriceTotal();
    // }


// WEBPACK FOOTER //
// ./src/app/components/products/product-detail/product-detail.component.ts